@if (init() === 'icon') {
	<span #IconWrapper [ngClass]="iconClass$() + ' ' + outerClass()" [ngStyle]="iconStyles$()">
		<i #IconElement [ngClass]="iconClass$()" [ngStyle]="iconStyles$()"></i>
		@if (counter()) {
			<span class="fa-layers-counter">{{ counter() }}</span>
		}
	</span>
} @else if (init() === 'stack' && backgroundIcon() && foregroundIcon()) {
	<span #IconWrapper [ngClass]="iconClass$()" [ngStyle]="iconStyles$()" class="fa-layers fa-fw">
		<!--Background-->
		<i #BackgroundIcon [ngClass]="bgIconData$()?.iconClass" [ngStyle]="bgIconData$()?.iconStyles" class="fa-layers-back"></i>
		<!--Foreground-->
		<i #ForegroundIcon [ngClass]="fgIconData$()?.iconClass" [ngStyle]="fgIconData$()?.iconStyles" [class.fa-layers-text]="fgIconData$()?.iconText">
			@if (fgIconData$()?.iconText) {
				{{ fgIconData$()?.iconText }}
			}
		</i>
	</span>
}
